import { authService } from "../../utils/authService";
import { errorHandler } from "../../components/shared/errorhandler";

interface InstanceFormData {
  id?: string;
  [key: string]: unknown;
}

interface InstanceCopyData {
  [key: string]: unknown;
}

interface BackupData {
  instanceId: string;
  id?: string;
  [key: string]: unknown;
}

interface OverwriteData {
  sourceInstanceId: string;
  [key: string]: unknown;
}

export const getCurrentUser = async () => {
  return await fetch("/api/user/loggedinUser", {
    headers: await authService.getAuthorizationHeader(),
  })
    .then(errorHandler)
    .then((response) => response.json());
};

export const getTenants = async () => {
  return await fetch("/api/v1/admin/instances/my", {
    headers: await authService.getAuthorizationHeader(),
  })
    .then(errorHandler)
    .then((response) => response.json());
};

export const getInstance = async () => {
  return await fetch("/api/v1/admin/instances", {
    headers: await authService.getAuthorizationHeader(),
  })
    .then(errorHandler)
    .then((response) => response.json());
};

// Stubbed SPC-only functions — these features are not supported locally

export const removeInstances = async (_id: string) => {
  return { isSuccess: false, message: "Instance removal not supported locally", data: [] };
};

export const editCreateInstance = async (_data: InstanceFormData) => {
  return { isSuccess: false, message: "Instance management not supported locally", data: [] };
};

export const copyFromInstance = async (_data: InstanceCopyData) => {
  return { isSuccess: false, message: "Instance copy not supported locally", data: [] };
};

export const clearCDPInstances = async (_id: string, _type: string) => {
  return { isSuccess: false, message: "CDP reset not supported locally" };
};

export const clearPrivacyInstances = async (_id: string) => {
  return { isSuccess: false, message: "Privacy reset not supported locally" };
};

export const getPubSubServiceUri = async (_hubName: string): Promise<string> => {
  return "";
};

export const getBackups = async (_data: { id: string }) => {
  return { backups: [] };
};

export const createInstancebackup = async (_data: BackupData) => {
  return { isSuccessful: false, message: "Backups not supported locally", entity: null as any };
};

export const removeInstancebackup = async (_data: BackupData) => {
  return { isSuccessful: false, message: "Backups not supported locally", entity: null as any };
};

export const overwriteInstance = async (_data: OverwriteData) => {
  return { isSuccessful: false, message: "Instance overwrite not supported locally" };
};

export const getDefaultInstanceById = async (_id: string) => {
  return {
    instanceDefault: {
      timezone: "",
      language: "",
      dateandNumberFormat: "",
      currency: "",
      domain: "",
    },
  };
};

export const changedInstanceLogCreate = async (_type: string) => {
  return {};
};
